(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.sectionEl = document.querySelector('.section-stedee-header');
      if (!this.sectionEl) return;

      this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.isAlwaysSticky = this.stickyType === 'always';
      this.currentScrollTop = 0;
      this.headerBounds = {};

      this.setHeaderHeight();
      new ResizeObserver(() => this.setHeaderHeight()).observe(this.sectionEl);

      if (this.stickyType !== 'none') {
        if (this.isAlwaysSticky) this.sectionEl.classList.add('shopify-section-header-sticky');
        window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        new IntersectionObserver((entries, obs) => {
          this.headerBounds = entries[0].intersectionRect;
          obs.disconnect();
        }).observe(this.sectionEl);
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.sectionEl.offsetHeight}px`);
    }

    onScroll() {
      const scrollTop = window.scrollY;
      const bottom = this.headerBounds.bottom || 0;
      const top = this.headerBounds.top || 0;

      if (scrollTop > this.currentScrollTop && scrollTop > bottom) {
        this.sectionEl.classList.add('scrolled-past-header');
        if (!this.isAlwaysSticky) requestAnimationFrame(() => {
          this.sectionEl.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          this.sectionEl.classList.remove('animate');
        });
      } else if (scrollTop < this.currentScrollTop && scrollTop > bottom) {
        this.sectionEl.classList.add('scrolled-past-header');
        if (!this.isAlwaysSticky) requestAnimationFrame(() => {
          this.sectionEl.classList.add('shopify-section-header-sticky', 'animate');
          this.sectionEl.classList.remove('shopify-section-header-hidden');
        });
      } else if (scrollTop <= top) {
        this.sectionEl.classList.remove('scrolled-past-header');
        if (!this.isAlwaysSticky) requestAnimationFrame(() => {
          this.sectionEl.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        });
      }
      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Drawer — runs immediately; section JS is deferred so DOM is already ready
  (function () {
    const drawer = document.getElementById('stedee-drawer');
    const hamburger = document.querySelector('[data-drawer-open]');
    if (!drawer || !hamburger) return;

    // Portal drawer + backdrop to <body> so sticky-header's transform: translateY(-100%)
    // doesn't contain the fixed-position drawer (CSS transform creates a new containing block
    // for fixed children, causing it to move off-screen when the header is hidden).
    const backdrop = document.querySelector('.stedee-drawer__backdrop');
    document.body.appendChild(drawer);
    if (backdrop) document.body.appendChild(backdrop);

    const closeTriggers = document.querySelectorAll('[data-drawer-close]');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = drawer.querySelector('a[href], button');
      if (first) first.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', openDrawer);
    closeTriggers.forEach(el => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const widget = document.querySelector('[data-pincode-widget]');
  if (!widget) return;

  const input  = widget.querySelector('[data-pincode-input]');
  const btn    = widget.querySelector('[data-pincode-check]');
  const result = widget.querySelector('[data-pincode-result]');

  // Metro pincodes first digit pairs for fast delivery
  const METRO_PREFIXES = ['11','12','13','40','41','42','43','44','56','57','58','59','60','63','64','69','70','71','72','74','75','76','77','78','79','80','83'];

  function getDelivery(pin) {
    if (!/^\d{6}$/.test(pin)) return null;
    const prefix = pin.slice(0, 2);
    const isMetro = METRO_PREFIXES.includes(prefix);
    const today = new Date();
    const daysAhead = isMetro ? 2 : 5;
    const delivery = new Date(today);
    let added = 0;
    while (added < daysAhead) {
      delivery.setDate(delivery.getDate() + 1);
      if (delivery.getDay() !== 0) added++; // skip Sundays
    }
    const dayName = delivery.toLocaleDateString('en-IN', { weekday: 'long' });
    const dateStr = delivery.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
    return { dayName, dateStr, cod: true };
  }

  function check() {
    const pin = input.value.trim();
    const info = getDelivery(pin);
    if (!info) {
      result.textContent = 'Enter a valid 6-digit pincode.';
      result.className = 'pdp-pincode__result pdp-pincode__result--error';
    } else {
      result.innerHTML = '✓ Delivery by <strong>' + info.dayName + ', ' + info.dateStr + '</strong>' +
        (info.cod ? ' &nbsp;·&nbsp; <span class="pdp-pincode__cod">COD available</span>' : '');
      result.className = 'pdp-pincode__result pdp-pincode__result--ok';
    }
    result.hidden = false;
  }

  btn.addEventListener('click', check);
  input.addEventListener('keydown', function(e) { if (e.key === 'Enter') check(); });
  input.addEventListener('input', function() {
    if (this.value.length === 6) check();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-v3-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-pv3-buy]');
  if (!root) return;

  // ── Gallery thumbs ──
  var mainImg = document.getElementById('pv3-main-image');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pv3-thumb]'));
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mainImg) {
        mainImg.removeAttribute('srcset');
        mainImg.src = btn.dataset.pv3Thumb;
      }
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // ── Plans, qty, price ──
  var plansWrap = root.querySelector('[data-pv3-plans]');
  var form = root.querySelector('[data-pv3-form]');
  if (!plansWrap || !form) return;

  var oneTime = parseInt(plansWrap.dataset.oneTimePrice, 10);
  var subPrice = parseInt(plansWrap.dataset.subscribePrice, 10);
  var saveAmount = parseInt(plansWrap.dataset.saveAmount, 10);
  var sellingPlanId = plansWrap.dataset.sellingPlanId;
  var qtyInput = form.querySelector('[data-pv3-qty-input]');
  var qtyDisplay = form.querySelector('[data-pv3-qty-display]');
  var ctaPrice = form.querySelector('[data-pv3-cta-price]');
  var heroPrice = root.querySelector('[data-pv3-hero-price]');
  var heroStrike = root.querySelector('[data-pv3-hero-strike]');
  var heroSave = root.querySelector('[data-pv3-hero-save]');

  var currency = plansWrap.dataset.currency || 'INR';
  var fmt = function (cents) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: currency,
      minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(cents / 100);
  };

  var state = { qty: 1, subscribe: true };

  var render = function () {
    var unit = state.subscribe ? subPrice : oneTime;
    if (qtyDisplay) qtyDisplay.textContent = state.qty;
    if (qtyInput) qtyInput.value = state.qty;
    if (ctaPrice) ctaPrice.textContent = fmt(unit * state.qty);
    if (heroPrice) heroPrice.textContent = fmt(unit);
    if (heroStrike) heroStrike.hidden = !state.subscribe;
    if (heroSave) heroSave.hidden = !state.subscribe;

    var stickyPrice = document.querySelector('[data-pv3-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = fmt(unit * state.qty);

    // selling plan input
    var planInput = form.querySelector('[data-pv3-selling-plan]');
    if (state.subscribe && sellingPlanId) {
      if (!planInput) {
        planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = 'selling_plan';
        planInput.setAttribute('data-pv3-selling-plan', '');
        form.appendChild(planInput);
      }
      planInput.value = sellingPlanId;
      planInput.disabled = false;
    } else if (planInput) {
      planInput.remove();
    }
  };

  plansWrap.addEventListener('change', function (e) {
    if (!e.target.matches('input[type="radio"]')) return;
    state.subscribe = e.target.value === 'subscribe';
    plansWrap.querySelectorAll('[data-pv3-plan]').forEach(function (label) {
      var isActive = (label.dataset.pv3Plan === 'subscribe') === state.subscribe;
      label.classList.toggle('is-active', isActive);
    });
    render();
  });

  form.querySelector('[data-pv3-qty-up]').addEventListener('click', function () {
    state.qty = Math.min(5, state.qty + 1);
    render();
  });
  form.querySelector('[data-pv3-qty-down]').addEventListener('click', function () {
    state.qty = Math.max(1, state.qty - 1);
    render();
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-v3-final-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.querySelector('[data-pv3-final-cta]');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var form = document.querySelector('[data-pv3-form]');
    if (form) {
      form.requestSubmit();
    } else {
      var buy = document.getElementById('pv3-buy');
      if (buy) buy.scrollIntoView({ behavior: 'smooth' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-v3-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-pv3-reviews]');
  if (!root) return;
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pv3-review-tab]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pv3-review-tag]'));
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tag = tab.dataset.pv3ReviewTab;
      tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      cards.forEach(function (card) {
        card.hidden = tag !== 'All' && card.dataset.pv3ReviewTag !== tag;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-v3-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-pv3-sticky]');
  if (!bar) return;

  // Show once the buy-box CTA scrolls out of view
  var trigger = document.querySelector('[data-pv3-atc]');
  if (trigger && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(trigger);
  } else {
    bar.classList.add('is-visible');
  }

  bar.querySelector('[data-pv3-sticky-atc]').addEventListener('click', function () {
    var form = document.querySelector('[data-pv3-form]');
    if (form) {
      form.requestSubmit();
    } else {
      var buy = document.getElementById('pv3-buy');
      if (buy) buy.scrollIntoView({ behavior: 'smooth' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stedee-cart"]) return;
  try {
    
(function() {
  const form = document.querySelector('form[action="/cart"]');
  if (!form) return;

  form.addEventListener('click', (e) => {
    const decreaseBtn = e.target.closest('[data-qty-decrease]');
    const increaseBtn = e.target.closest('[data-qty-increase]');
    const removeBtn = e.target.closest('[data-remove-item]');

    if (decreaseBtn) {
      e.preventDefault();
      const input = decreaseBtn.parentElement.querySelector('[data-qty-input]');
      input.value = Math.max(0, parseInt(input.value) - 1);
      updateCartDebounced();
    } else if (increaseBtn) {
      e.preventDefault();
      const input = increaseBtn.parentElement.querySelector('[data-qty-input]');
      input.value = parseInt(input.value) + 1;
      updateCartDebounced();
    } else if (removeBtn) {
      e.preventDefault();
      const row = removeBtn.closest('[data-line-index]');
      const input = row.querySelector('[data-qty-input]');
      input.value = 0;
      updateCartDebounced();
    }
  });

  form.addEventListener('change', (e) => {
    if (e.target.matches('[data-qty-input]')) {
      updateCartDebounced();
    }
  });

  let debounceTimer;
  function updateCartDebounced() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const formData = new FormData(form);
      fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(r => r.json())
      .then(() => {
        window.location.reload();
      });
    }, 500);
  }

  const checkoutBtn = document.querySelector('a.codk-cart-checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function(e) {
      if (checkoutBtn.hasAttribute('codk-data-event-listener')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var tryOpen = function() {
        var iframe = document.getElementById('codk-full-modal-svelte');
        if (!iframe) return false;
        try {
          var iw = iframe.contentWindow;
          if (!iw || !iw.appStore) return false;
          if (iw.appActions && typeof iw.appActions.openModal === 'function') {
            iw.appActions.openModal();
          } else {
            iw.appStore.update(function(s) { return Object.assign({}, s, { isOpen: true }); });
          }
          var scrollY = window.scrollY || window.pageYOffset || 0;
          window.codkScrollY = scrollY;
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
          document.body.style.top = '-' + scrollY + 'px';
          return true;
        } catch (_) { return false; }
      };
      if (!tryOpen()) {
        var attempts = 0;
        var poll = setInterval(function() {
          attempts++;
          if (tryOpen() || attempts > 20) clearInterval(poll);
        }, 400);
      }
    }, true);
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector("[data-sticky-buy]");
  if (!bar) return;
  var stickyForm = bar.querySelector("[data-sticky-form]");
  var stickyIdInput = bar.querySelector("[data-sticky-variant-id]");
  if (!stickyForm || !stickyIdInput) return;

  function getMainForm() {
    return document.querySelector("[data-product-form]:not([data-sticky-form])");
  }

  function syncFromMain() {
    var mainForm = getMainForm();
    if (!mainForm) return;
    var mainId = mainForm.querySelector('input[name="id"]');
    if (mainId && mainId.value) stickyIdInput.value = mainId.value;
    var mainPlan = mainForm.querySelector('input[name="selling_plan"]');
    var existingPlan = stickyForm.querySelector('input[name="selling_plan"]');
    if (mainPlan) {
      if (existingPlan) {
        existingPlan.value = mainPlan.value;
      } else {
        var inp = document.createElement("input");
        inp.type = "hidden";
        inp.name = "selling_plan";
        inp.value = mainPlan.value;
        stickyForm.appendChild(inp);
      }
    } else if (existingPlan) {
      existingPlan.remove();
    }
  }

  syncFromMain();

  var mainForm = getMainForm();
  if (mainForm) {
    mainForm.addEventListener("change", syncFromMain);
    new MutationObserver(syncFromMain).observe(mainForm, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["value"]
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
